import React from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { roleid, token } from "../Actions/AuthAction";
import { selectCandidate } from "../Actions/DriveAction";
import CONFIG from "../../config";

export const DriveSelectedCandidateList = (props) => {
  const userrole = roleid();
  const sampleImage = "../assets/img/profile.png";
  console.log(props);
  const handleSelect = (candidateid, job_id, employer_id) => {
    Swal.fire({
      title: "Do you want to select this candidate?",
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: "Yes",
      denyButtonText: `No`,
    }).then((result) => {
      if (result.isConfirmed) {
        selectCandidate({
          employerid: employer_id,
          jobid: job_id,
          driveid: props.driveid,
          loginusertoken: token(),
          candidateid: candidateid,
        }).then((res) => {
          if (res.status) {
            Swal.fire("Candidate has been Selected.");
            props.getData();
          }
          if (res.error) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: res.message,
            });
          }
        });
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };
  return (
    <div>
      <>
        <div className="row ">
          <div className="col-md-12">
            <h4 className="table_heading position-relative">
              {props.heading}-{props.type}
            </h4>
          </div>
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <div className="">
                  <form className="d-flex justify-content-between form-group tableform">
                    <div>
                      <select className="form-control">
                        <option>Filter</option>
                        <option value="">All</option>
                        <option>Pending</option>
                        <option>Approve</option>
                        <option>Rejected</option>
                      </select>
                    </div>
                    <div className="search-box mb-2">
                      <input
                        className="search-text"
                        type="text"
                        placeholder="Search in table"
                      />
                      <a href="#" className="search-btn">
                        <i className="fas fa-search"></i>
                      </a>
                    </div>
                  </form>
                </div>
                <div className="table-responsive">
                  <table
                    className="table table-bordered"
                    width="100%"
                    cellspacing="0"
                  >
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Profile</th>
                        <th>Full Name</th>
                        <th>Gender</th>
                        <th className="text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {props.candidateList &&
                        props.candidateList.map((item, index) => (
                          <tr>
                            <td>{index + 1}</td>
                            <td>
                              {item && item.candidate.profilepic ? (
                                <img
                                  src={`${CONFIG.IMAGE_URL}/${item.candidate.profilepic}`}
                                  alt="Image not available"
                                  className="listprofilepic shadow"
                                />
                              ) : (
                                <img
                                  src={sampleImage}
                                  alt="Image not available"
                                  className="listprofilepic shadow"
                                />
                              )}
                            </td>

                            <td>
                              {item.candidate.firstname}{" "}
                              {item.candidate.middlename}{" "}
                              {item.candidate.lastname}
                            </td>
                            <td>
                              {item.candidate.gender == 1
                                ? "Male"
                                : item.candidate.gender == 2
                                ? "Female"
                                : "Others"}
                            </td>

                            <td className="text-center">
                              <span className="tabledropdown">
                                <span className="abtn">
                                  <i
                                    class="fa fa-ellipsis-v"
                                    id="dropdownMenuLink"
                                    data-toggle="dropdown"
                                  ></i>
                                  <div
                                    class="dropdown-menu editdrp"
                                    aria-labelledby="dropdownMenuLink"
                                  >
                                    {userrole == "3" || userrole == "4"
                                      ? !props.select && (
                                          <a
                                            class="dropdown-item"
                                            onClick={() =>
                                              handleSelect(
                                                item.id,
                                                item.job_id,
                                                item.employer_id
                                              )
                                            }
                                          >
                                            Select
                                          </a>
                                        )
                                      : null}
                                    {!props.select && (
                                      <Link class="dropdown-item" to="/">
                                        Send Assesment URL
                                      </Link>
                                    )}

                                    {props.driveid && props.type == "1" ? (
                                      <Link
                                        class="dropdown-item"
                                        to={`/candidateapplieddetail/${props.driveid}/${item.id}/${item.job_id}`}
                                      >
                                        View Details
                                      </Link>
                                    ) : (
                                      <></>
                                    )}

                                    {props.driveid && props.type == "2" ? (
                                      <Link
                                        class="dropdown-item"
                                        to={`/candidatedetail/${props.driveid}/${item.candidate.id}/${item.job_id}`}
                                      >
                                        View Details
                                      </Link>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                </span>
                              </span>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};
